/**
 * Le block <convertisseur-devise> appelé pour afficher un convertisseur de devises
 * DOC : https://developer.mozilla.org/fr/docs/Web/API/Web_components/Using_custom_elements
 */
class convertisseur extends HTMLElement {
	constructor() {

		super();
		this.shadow = this.attachShadow({
			mode: "open"
		});

		/// Config openexchangerates
		const API = 'https://openexchangerates.org/api/latest.json';
		const API_CODE = '399f7a555c064dc48409500548b67fa5';
		this.URL = API + '?app_id=' + API_CODE;

		/// On récupère les infos depuis la view html
		this.localDevise = this.dataset.localDevise === undefined ? "EUR" : this.dataset.localDevise;
		this.devise = this.dataset.devise === undefined ? "EUR" : this.dataset.devise;
		this.titre = this.dataset.titre === undefined ? "Convertisseur" : this.dataset.titre;
		this.localLibelle = this.dataset.localLibelle === undefined ? "euro" : this.dataset.localLibelle;
		this.deviseLibelle = this.dataset.deviseLibelle === undefined ? "" : this.dataset.deviseLibelle;

		/// On garde en session le taux de change pour ne pas faire une nouvelle requête
		this.storage = sessionStorage.getItem('exchange');
	}

	get exchange() {
		let self = this;
		return new Promise(async function (resolve, reject) {
			const res = await fetch(self.URL)
			resolve(res.json());
			reject(res);
		}).then((json) => {
			sessionStorage.setItem('exchange', JSON.stringify(json.rates));
			this.storage = sessionStorage.getItem('exchange');
		});
	}

	listeners() {
		let self = this;
		this.inputLocalCurrency.addEventListener('focusin', (e) => {
			self.storage === null && self.exchange;
			this.localCurrency.innerText = "";
			e.target.value = "";
		})
		this.inputLocalCurrency.addEventListener('input', (event) => {
			let valueConverted = this.conversion(JSON.parse(this.storage), event.target.value).toFixed(0);
			this.foreignCurrency.innerText = new Intl.NumberFormat('fr-FR', {
				style: 'currency',
				currency: this.devise
			}).format(valueConverted);

			this.localCurrency.innerText = new Intl.NumberFormat('fr-FR', {
				style: 'currency',
				currency: this.localDevise
			}).format(this.inputLocalCurrency.value);

			this.inputForeignCurrency.value = valueConverted;
		})
		this.inputForeignCurrency.addEventListener('focusin', (e) => {
			self.storage === null && self.exchange;
			this.foreignCurrency.innerText = "";
			e.target.value = "";
		})
		this.inputForeignCurrency.addEventListener('input', (event) => {
			let valueConverted = this.conversion(JSON.parse(this.storage), event.target.value, false).toFixed(0);

			this.foreignCurrency.innerText = new Intl.NumberFormat('fr-FR', {
				style: 'currency',
				currency: this.devise
			}).format(this.inputForeignCurrency.value);

			this.localCurrency.innerText = new Intl.NumberFormat('fr-FR', {
				style: 'currency',
				currency: this.localDevise
			}).format(valueConverted);

			this.inputLocalCurrency.value = valueConverted;
		})
	}

	conversion(objExchange, value, direction = true) {
		let txDevise = objExchange[this.devise];
		let txDollar = objExchange[this.localDevise];
		let conversion = '';
		if (direction) {
			return conversion = (value / txDollar) * txDevise;
		} else {
			return conversion = (value * txDollar) / txDevise;
		}
	}

	connectedCallback() {
		let self = this;

		/// On génère le html
		this.render();

		/// Elements html
		this.localCurrency = this.shadowRoot.getElementById('localCurrency');
		this.foreignCurrency = this.shadowRoot.getElementById('foreignCurrency');
		this.inputLocalCurrency = this.shadowRoot.getElementById('inputLocalCurrency');
		this.inputForeignCurrency = this.shadowRoot.getElementById('inputForeignCurrency');

		/// On écoute les événements
		this.listeners()

		/// Gestion show & hide
		document.addEventListener('show:widget', () => {
			self.hidden = !self.hidden;
		})
	}

	render() {

		this.shadowRoot.innerHTML = `
				<style>
				.bloc--widget {
				padding-top:30px;
				padding-bottom:30px;
				}
				.bloc__titre {
					color:  var(--app-color-primary);
					font-size: var(--app-fontSize-base);
					font-weight: 700;
					line-height: 1;
				}
				input {
					background: #efefef;
					color: transparent;
					font-weight: 300;
					line-height: 30px;
					border-radius: 12px;
					border: none;
					caret-color: var(--app-color-primary);
					color: transparent;
					display: flex;
					font-size: 14px;
					justify-content: center;
					padding: 10px 20px;
					text-overflow: ellipsis;
					width: 215px;
					appearance: textfield;
					margin-bottom: 10px;
				}

				input::selection,
				input::placeholder {
					color: var(--app-color-primary);
				}

				input:-ms-input-placeholder {
					color: var(--app-color-primary);
				}

				span {
					color: var(--app-color-primary);
					display: flex;
					font-size: 14px;
					height: 50px;
					justify-content: center;
					line-height: 17px;
					padding: 16px 20px;
					pointer-events: none;
					position: absolute;
				}
				</style>


			<div class="bloc bloc--widget" id="widgetCurrency">
				<h3 class="bloc__titre">${this.titre}</h3>
				<div class="widget">
					<span id="localCurrency"></span><input id="inputLocalCurrency" type="number" placeholder="Montant en ${this.localLibelle}">
					<span id="foreignCurrency"></span><input id="inputForeignCurrency" type="number" placeholder="Montant en ${this.deviseLibelle}">
				</div>
			</div>`;
	}
}

/// On ajoute le nouvel élément
customElements.define("convertisseur-devise", convertisseur);